// 增强版个性化解读系统
// 通过多维度分析生成独一无二的结果

import { archetypes } from '../data/archetypes';

// ============ 基础特质片段库 ============
const traitFragments = {
  ruler: {
    high: ['天生的领导气质', '善于在混乱中建立秩序', '决策果断且负责', '追求掌控感'],
    medium: ['有一定的组织能力', '偶尔展现领导潜质', '能在需要时站出来'],
    low: ['更倾向于追随而非引领', '享受被安排的轻松'],
  },
  hero: {
    high: ['行动力超强', '面对挑战毫不退缩', '正义感爆棚', '渴望证明自己'],
    medium: ['关键时刻能挺身而出', '有一定的勇气', '不轻易认输'],
    low: ['更喜欢稳妥的方式', '避免不必要的冲突'],
  },
  sage: {
    high: ['求知欲旺盛', '善于深度思考', '追求真理', '分析能力强'],
    medium: ['对知识有一定兴趣', '偶尔会深入研究', '逻辑清晰'],
    low: ['更注重实践而非理论', '相信直觉'],
  },
  explorer: {
    high: ['向往自由和远方', '不断寻找新体验', '讨厌被束缚', '好奇心旺盛'],
    medium: ['偶尔渴望冒险', '对新事物保持好奇', '喜欢尝鲜'],
    low: ['更享受熟悉的环境', '珍惜稳定'],
  },
  outlaw: {
    high: ['质疑权威', '打破常规', '不走寻常路', '独立思考'],
    medium: ['偶尔会挑战规则', '有自己的主见', '不盲从'],
    low: ['更倾向于遵守规则', '重视和谐'],
  },
  magician: {
    high: ['善于创造愿景', '相信可能性', '能把想象变为现实', '直觉敏锐'],
    medium: ['有一定的想象力', '偶尔会做白日梦', '相信奇迹'],
    low: ['更脚踏实地', '务实主义者'],
  },
  creator: {
    high: ['创意无限', '追求独特', '表达欲强烈', '审美在线'],
    medium: ['有一定的创造力', '偶尔会有灵感', '欣赏美好事物'],
    low: ['更欣赏他人的创作', '实用主义'],
  },
  lover: {
    high: ['重视情感连接', '善于表达爱', '对美敏感', '渴望亲密'],
    medium: ['珍惜亲密关系', '有一定的浪漫情怀', '重感情'],
    low: ['更理性地看待感情', '保持独立'],
  },
  caregiver: {
    high: ['天生的照顾者', '共情能力强', '乐于付出', '温暖体贴'],
    medium: ['关心身边的人', '偶尔会照顾他人', '善解人意'],
    low: ['更注重自我边界', '先照顾好自己'],
  },
  jester: {
    high: ['幽默感十足', '善于活跃气氛', '乐观开朗', '快乐感染力强'],
    medium: ['偶尔会开玩笑', '有一定的幽默感', '心态轻松'],
    low: ['更倾向于严肃', '深沉内敛'],
  },
  everyman: {
    high: ['追求归属感', '平易近人', '重视真实连接', '接地气'],
    medium: ['容易相处', '不喜欢出风头', '随和'],
    low: ['更追求独特性', '不怕与众不同'],
  },
  innocent: {
    high: ['保持纯真', '相信美好', '乐观向上', '心态年轻'],
    medium: ['对世界有一定信任', '偶尔会天真', '保持希望'],
    low: ['更现实地看待世界', '成熟稳重'],
  },
};

// ============ 132种主副组合的独特描述 ============
const combinationDescriptions = {
  // ruler 作为主原型
  'ruler+hero': '你是战场上的将军，既能运筹帷幄，又能身先士卒。你的领导力来自于你愿意承担最大的风险。',
  'ruler+sage': '你是智慧的统治者，用知识武装决策，用理性引领方向。你相信最好的领导是让每个人都变得更聪明。',
  'ruler+explorer': '你是开拓型的领袖，不满足于守成，总在寻找新的疆域。你的野心不是控制，而是扩展可能性。',
  'ruler+outlaw': '你是改革派的掌权者，用权力来打破旧秩序。你知道有时候必须先破坏才能重建。',
  'ruler+magician': '你是愿景型的领导者，能看到别人看不到的未来，并有能力带领团队走向那里。',
  'ruler+creator': '你是有审美的决策者，追求的不只是效率，还有优雅。你相信好的秩序本身就是一种艺术。',
  'ruler+lover': '你是有温度的领导者，在追求目标的同时不忘关注人心。你的权威来自于被爱戴，而非被畏惧。',
  'ruler+caregiver': '你是家长式的领袖，把团队当作家人来照顾。你的控制欲背后是深深的责任感。',
  'ruler+jester': '你是轻松的掌控者，能在严肃的决策中保持幽默。你知道笑声是最好的团队粘合剂。',
  'ruler+everyman': '你是亲民的领导者，虽然站在高处，却从不俯视。你的权威来自于真实和可靠。',
  'ruler+innocent': '你是理想主义的统治者，相信权力应该用来创造美好。你的愿景总是充满希望。',
  
  // hero 作为主原型
  'hero+ruler': '你是有战略的勇士，不只会冲锋，还懂得何时进退。你的勇气是有智慧的勇气。',
  'hero+sage': '你是思考型的行动派，每一次出击都经过深思熟虑。你相信真正的勇气需要智慧的支撑。',
  'hero+explorer': '你是冒险家中的战士，在未知中寻找挑战。对你来说，最大的敌人是平庸和无聊。',
  'hero+outlaw': '你是反叛的斗士，为打破不公而战。你的战场不是传统意义上的，而是观念和规则的边界。',
  'hero+magician': '你是相信奇迹的勇者，即使在最绝望的时刻也能找到转机。你的乐观是一种战斗力。',
  'hero+creator': '你是有创意的挑战者，用独特的方式解决问题。你的战斗风格是别人无法复制的。',
  'hero+lover': '你是为爱而战的骑士，你的勇气来源于想要保护的人。感情是你最强大的动力。',
  'hero+caregiver': '你是守护型的英雄，战斗是为了保护而非征服。你的力量用来庇护弱小。',
  'hero+jester': '你是乐观的战士，即使在战斗中也能保持微笑。你用幽默化解压力，用笑容鼓舞士气。',
  'hero+everyman': '你是平民英雄，没有光环却有担当。你证明了普通人也能做出不普通的事。',
  'hero+innocent': '你是纯粹的勇者，为了相信的美好而战。你的力量来自于对世界最初的信任。',
  
  // sage 作为主原型
  'sage+ruler': '你是哲人王，用智慧指引方向，用知识建立秩序。你相信最好的统治是启蒙。',
  'sage+hero': '你是知行合一的智者，不只思考，还敢于实践。你的智慧不是书斋里的，而是战场上的。',
  'sage+explorer': '你是求知的旅人，每一次探索都是为了理解更多。你的好奇心驱动着你走向未知。',
  'sage+outlaw': '你是质疑一切的思想家，不接受任何未经检验的"真理"。你的叛逆是智识上的叛逆。',
  'sage+magician': '你是神秘学的研究者，对表象之下的规律充满兴趣。你相信理解就是一种魔法。',
  'sage+creator': '你是有深度的创作者，你的作品总是承载着思想。你追求的是有意义的美。',
  'sage+lover': '你是懂得爱的哲学家，用理性理解感性。你知道最深的智慧是关于人心的智慧。',
  'sage+caregiver': '你是温暖的导师，用知识帮助他人成长。你的智慧不是用来炫耀，而是用来分享。',
  'sage+jester': '你是幽默的智者，能用轻松的方式讲述深刻的道理。你知道笑声是最好的老师。',
  'sage+everyman': '你是接地气的思考者，你的智慧来自生活而非书本。你用常识解决复杂问题。',
  'sage+innocent': '你是保持好奇的学者，像孩子一样对世界充满疑问。你的智慧没有让你变得世故。',

  // explorer 作为主原型
  'explorer+ruler': '你是有目标的探索者，你的冒险不是漫无目的的，而是为了开拓新的领地。',
  'explorer+hero': '你是勇敢的冒险家，越危险的地方越吸引你。你在挑战中找到存在的意义。',
  'explorer+sage': '你是学习型的旅人，每一次旅程都是一堂课。你收集的不是纪念品，而是见识。',
  'explorer+outlaw': '你是规则的逃离者，用脚步投票反对一切束缚。你的自由是用行动争取的。',
  'explorer+magician': '你是相信奇遇的旅人，总能在路上遇到神奇的人和事。你的旅程充满魔幻色彩。',
  'explorer+creator': '你是采风的艺术家，从世界各地汲取灵感。你的创作是旅途的结晶。',
  'explorer+lover': '你是浪漫的流浪者，在路上寻找心灵的归属。你相信真爱可能在下一个转角。',
  'explorer+caregiver': '你是带着使命的旅人，探索是为了帮助更多的人。你把温暖带到每一个角落。',
  'explorer+jester': '你是快乐的背包客，旅途中总是笑声不断。你用幽默化解旅途的疲惫。',
  'explorer+everyman': '你是平凡的旅人，不追求极限，只享受在路上的感觉。你的旅行是生活的一部分。',
  'explorer+innocent': '你是充满好奇的探险家，用孩子的眼光看世界。每一次出发都像第一次。',
  
  // outlaw 作为主原型
  'outlaw+ruler': '你是革命者，用反叛来建立新秩序。你打破规则不是为了混乱，而是为了更好的规则。',
  'outlaw+hero': '你是反英雄，用不被认可的方式做正确的事。你的正义不需要掌声。',
  'outlaw+sage': '你是异端思想家，质疑一切被视为理所当然的东西。你的智慧是颠覆性的。',
  'outlaw+explorer': '你是边界的挑战者，总是走在规则允许的边缘之外。你的自由是争取来的。',
  'outlaw+magician': '你是暗黑魔法师，用非常规的方式创造奇迹。你相信规则是用来打破的。',
  'outlaw+creator': '你是先锋艺术家，你的创作总是挑战主流审美。你用作品宣告你的态度。',
  'outlaw+lover': '你是禁忌之爱的追随者，不在乎世俗的眼光。你的爱是勇敢的爱。',
  'outlaw+caregiver': '你是地下守护者，用不被认可的方式保护弱者。你的善良是叛逆的善良。',
  'outlaw+jester': '你是讽刺大师，用幽默揭露虚伪。你的笑话是最锋利的武器。',
  'outlaw+everyman': '你是沉默的反抗者，表面融入却内心独立。你的叛逆是安静的叛逆。',
  'outlaw+innocent': '你是纯真的反叛者，因为相信美好所以无法接受丑恶。你的愤怒来自于爱。',
  
  // magician 作为主原型
  'magician+ruler': '你是造梦的王者，能把愿景变成现实。你的领导力来自于让人相信不可能。',
  'magician+hero': '你是奇迹的创造者，在绝境中总能找到出路。你的魔法是永不放弃。',
  'magician+sage': '你是神秘的学者，研究表象之下的规律。你相信理解就是掌控。',
  'magician+explorer': '你是寻找奇迹的旅人，相信世界上还有未被发现的魔法。你的旅程充满惊喜。',
  'magician+outlaw': '你是打破现实的术士，用想象力挑战"不可能"。你的魔法是颠覆性的。',
  'magician+creator': '你是炼金术士，能把平凡变成神奇。你的创作过程本身就是魔法。',
  'magician+lover': '你是爱情魔法师，相信爱能创造奇迹。你的感情世界充满魔幻色彩。',
  'magician+caregiver': '你是治愈系魔法师，用温暖的力量帮助他人。你的魔法是让人相信美好。',
  'magician+jester': '你是快乐的魔术师，用惊喜和欢笑感染他人。你的魔法是让人微笑。',
  'magician+everyman': '你是日常生活中的魔法师，能在平凡中发现神奇。你的魔法是改变视角。',
  'magician+innocent': '你是纯真的梦想家，相信童话可以成真。你的魔法来自于最初的相信。',
  
  // creator 作为主原型
  'creator+ruler': '你是有远见的创作者，你的作品不只是表达，还是引领。你用创意建立影响力。',
  'creator+hero': '你是战斗型的艺术家，用作品挑战世界。你的创作是一种宣言。',
  'creator+sage': '你是有深度的创作者，每一件作品都承载思想。你追求的是有意义的美。',
  'creator+explorer': '你是采风的艺术家，从世界各地汲取灵感。你的创作是旅途的结晶。',
  'creator+outlaw': '你是先锋派，你的创作总是挑战边界。你用作品打破陈规。',
  'creator+magician': '你是炼金术士，能把想象变成现实。你的创作过程充满魔力。',
  'creator+lover': '你是为爱创作的艺术家，感情是你最大的灵感来源。你的作品充满情感。',
  'creator+caregiver': '你是治愈系创作者，用作品温暖他人。你相信美可以治愈。',
  'creator+jester': '你是有趣的创作者，你的作品总能让人会心一笑。你用创意传递快乐。',
  'creator+everyman': '你是接地气的创作者，你的作品来自生活，也回归生活。你的美是日常的美。',
  'creator+innocent': '你是纯真的创作者，保持着孩子般的想象力。你的作品有一种天然的纯净。',

  // lover 作为主原型
  'lover+ruler': '你是有主见的爱人，在感情中不失自我。你的爱是有力量的爱。',
  'lover+hero': '你是为爱而战的骑士，愿意为所爱的人付出一切。你的勇气来自于爱。',
  'lover+sage': '你是懂得爱的哲学家，用理性理解感性。你的爱是有智慧的爱。',
  'lover+explorer': '你是浪漫的旅人，在世界各地寻找心动的感觉。你的爱是自由的爱。',
  'lover+outlaw': '你是禁忌之爱的追随者，不在乎世俗眼光。你的爱是勇敢的爱。',
  'lover+magician': '你是爱情魔法师，相信爱能创造奇迹。你的爱是神奇的爱。',
  'lover+creator': '你是为爱创作的艺术家，用作品表达感情。你的爱是有美感的爱。',
  'lover+caregiver': '你是温柔的爱人，用关怀表达爱意。你的爱是滋养的爱。',
  'lover+jester': '你是快乐的爱人，让感情充满欢笑。你的爱是轻松的爱。',
  'lover+everyman': '你是真实的爱人，不需要浪漫的包装。你的爱是踏实的爱。',
  'lover+innocent': '你是纯真的爱人，相信童话般的爱情。你的爱是纯净的爱。',
  
  // caregiver 作为主原型
  'caregiver+ruler': '你是家长式的照顾者，用责任感包裹关爱。你的照顾是有秩序的照顾。',
  'caregiver+hero': '你是守护型的照顾者，愿意为保护他人而战。你的温柔背后是力量。',
  'caregiver+sage': '你是智慧的导师，用知识帮助他人成长。你的照顾是启发式的照顾。',
  'caregiver+explorer': '你是带着使命的旅人，把温暖带到每一个角落。你的照顾没有边界。',
  'caregiver+outlaw': '你是地下守护者，用不被认可的方式保护弱者。你的善良是叛逆的善良。',
  'caregiver+magician': '你是治愈系魔法师，用温暖的力量帮助他人。你的照顾有神奇的效果。',
  'caregiver+creator': '你是用创意表达关爱的人，你的照顾是有美感的照顾。',
  'caregiver+lover': '你是深情的照顾者，用爱滋养身边的人。你的照顾充满温情。',
  'caregiver+jester': '你是快乐的照顾者，用欢笑治愈他人。你的照顾是轻松的照顾。',
  'caregiver+everyman': '你是平凡的守护者，默默付出不求回报。你的照顾是踏实的照顾。',
  'caregiver+innocent': '你是纯真的照顾者，相信善良的力量。你的照顾是无条件的照顾。',
  
  // jester 作为主原型
  'jester+ruler': '你是有影响力的开心果，用幽默建立连接。你的快乐是有感染力的快乐。',
  'jester+hero': '你是乐观的战士，用笑容面对挑战。你的幽默是一种勇气。',
  'jester+sage': '你是幽默的智者，用轻松的方式讲述深刻的道理。你的快乐是有深度的快乐。',
  'jester+explorer': '你是快乐的旅人，在路上收集笑声。你的幽默来自于见多识广。',
  'jester+outlaw': '你是讽刺大师，用幽默揭露虚伪。你的笑话是最锋利的武器。',
  'jester+magician': '你是快乐的魔术师，用惊喜和欢笑感染他人。你的幽默有神奇的效果。',
  'jester+creator': '你是有趣的创作者，你的作品总能让人会心一笑。你的快乐是有创意的快乐。',
  'jester+lover': '你是快乐的爱人，让感情充满欢笑。你的幽默是表达爱的方式。',
  'jester+caregiver': '你是用欢笑治愈他人的人，你的照顾是轻松的照顾。',
  'jester+everyman': '你是大家的开心果，用幽默拉近距离。你的快乐是接地气的快乐。',
  'jester+innocent': '你是纯真的快乐使者，笑声里没有讽刺。你的幽默是温暖的幽默。',
  
  // everyman 作为主原型
  'everyman+ruler': '你是亲民的领导者，虽然有能力却不张扬。你的可靠来自于真实。',
  'everyman+hero': '你是平民英雄，没有光环却有担当。你证明普通人也能不普通。',
  'everyman+sage': '你是接地气的智者，用常识解决问题。你的智慧来自生活。',
  'everyman+explorer': '你是平凡的旅人，不追求极限，只享受在路上。你的旅行是生活的一部分。',
  'everyman+outlaw': '你是沉默的反抗者，表面融入却内心独立。你的叛逆是安静的叛逆。',
  'everyman+magician': '你是日常生活中的魔法师，能在平凡中发现神奇。',
  'everyman+creator': '你是接地气的创作者，你的作品来自生活也回归生活。',
  'everyman+lover': '你是真实的爱人，不需要浪漫的包装。你的爱是踏实的爱。',
  'everyman+caregiver': '你是默默付出的守护者，不求回报只求心安。',
  'everyman+jester': '你是大家的开心果，用幽默拉近距离。你让人感到轻松自在。',
  'everyman+innocent': '你是保持纯真的普通人，在平凡中相信美好。',
  
  // innocent 作为主原型
  'innocent+ruler': '你是理想主义的领导者，相信权力应该用来创造美好。',
  'innocent+hero': '你是纯粹的勇者，为了相信的美好而战。你的力量来自于信念。',
  'innocent+sage': '你是保持好奇的学者，像孩子一样对世界充满疑问。',
  'innocent+explorer': '你是充满好奇的探险家，用孩子的眼光看世界。每一次出发都像第一次。',
  'innocent+outlaw': '你是纯真的反叛者，因为相信美好所以无法接受丑恶。',
  'innocent+magician': '你是纯真的梦想家，相信童话可以成真。你的魔法来自于相信。',
  'innocent+creator': '你是纯真的创作者，保持着孩子般的想象力。你的作品有天然的纯净。',
  'innocent+lover': '你是纯真的爱人，相信童话般的爱情。你的爱是最初的爱。',
  'innocent+caregiver': '你是纯真的照顾者，相信善良的力量。你的付出是无条件的。',
  'innocent+jester': '你是纯真的快乐使者，笑声里没有讽刺只有温暖。',
  'innocent+everyman': '你是保持纯真的普通人，在平凡中相信美好。你是人群中的一道光。',
};


// ============ 得分分布模式描述 ============
const distributionPatterns = {
  dominant: {
    // 一枝独秀型（主原型得分远超其他）
    description: '你的能量高度集中，主导原型的特质在你身上表现得非常鲜明。这种专注让你在特定领域有着独特的优势，但也意味着你可能需要有意识地发展其他维度。',
    advice: '尝试在日常中有意识地激活你的次要原型能量，这会让你更加立体。',
  },
  balanced: {
    // 均衡型（多个原型得分接近）
    description: '你的能量分布相对均衡，多种原型特质在你身上和谐共存。这种多元性让你能够灵活应对不同情境，但有时也可能让你感到"我到底是谁"的困惑。',
    advice: '接纳你的多面性，它是你的优势而非弱点。在不同场合展现不同的自己，这正是你的独特之处。',
  },
  dual: {
    // 双核型（两个原型得分都很高）
    description: '你有两个同样强大的核心原型，它们在你内心形成了一种动态的张力。这种双重性让你既有深度又有广度，但有时也可能感到内心的拉扯。',
    advice: '学会让两个原型轮流主导，而不是让它们互相竞争。它们是你的左右手，而非对手。',
  },
  gradient: {
    // 渐变型（得分呈阶梯状递减）
    description: '你的原型能量呈现出清晰的层次结构，从主导到辅助再到潜在，形成了一个完整的能量光谱。这种结构让你既有核心特质，又有丰富的辅助能量可以调用。',
    advice: '你的第三、第四原型是你的隐藏技能，在特定情境下可以有意识地激活它们。',
  },
};

// ============ 第三原型影响描述 ============
const tertiaryInfluences = {
  ruler: '你内心深处有一个小小的"掌控者"，在关键时刻会站出来帮你做决定。',
  hero: '你骨子里有一股不服输的劲，虽然平时不显山露水，但关键时刻会爆发。',
  sage: '你有一个隐藏的"分析师"人格，会在复杂情况下帮你理清思路。',
  explorer: '你内心有一个小小的"流浪者"，偶尔会渴望打破日常，去看看外面的世界。',
  outlaw: '你心里住着一个小叛逆，虽然大多数时候很乖，但偶尔会想打破规则。',
  magician: '你有一个隐藏的"造梦师"人格，相信生活中存在着神奇的可能性。',
  creator: '你内心有一个小小的"艺术家"，渴望表达和创造，只是还没找到出口。',
  lover: '你骨子里是个重感情的人，虽然可能不常表露，但对亲密关系有着深深的渴望。',
  caregiver: '你内心有一个温柔的"照顾者"，看到需要帮助的人会本能地想伸出手。',
  jester: '你心里住着一个小丑，虽然平时可能比较严肃，但其实很懂得生活的乐趣。',
  everyman: '你内心渴望归属和连接，虽然可能表现得很独立，但其实很珍惜真实的关系。',
  innocent: '你心里保留着一片纯真的角落，相信世界上还有美好的事情会发生。',
};

// ============ 得分差距分析 ============
const gapAnalysis = {
  large: {
    // 主副差距大（>5分）
    description: '你的主导原型非常突出，它几乎定义了你是谁。',
    implication: '这种清晰的自我认知是你的优势，但也要小心不要被单一标签限制。',
  },
  medium: {
    // 主副差距中等（3-5分）
    description: '你的主导原型明显，但次要原型也有相当的影响力。',
    implication: '这种组合让你既有核心特质，又有灵活性。',
  },
  small: {
    // 主副差距小（<3分）
    description: '你的主导和次要原型几乎同样强大，它们共同塑造了你。',
    implication: '你可能经常在两种模式之间切换，这是你的独特之处。',
  },
};

// ============ 分析得分分布模式 ============
function analyzeDistribution(scores) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const top3 = sorted.slice(0, 3).map(s => s[1]);
  const max = top3[0];
  const second = top3[1];
  const third = top3[2];
  
  // 计算标准差来判断分布
  const values = Object.values(scores);
  const mean = values.reduce((a, b) => a + b, 0) / values.length;
  const variance = values.reduce((a, b) => a + Math.pow(b - mean, 2), 0) / values.length;
  const stdDev = Math.sqrt(variance);
  
  if (max - second >= 5) {
    return 'dominant'; // 一枝独秀
  } else if (max - second <= 2 && second - third <= 2) {
    return 'balanced'; // 均衡型
  } else if (max - second <= 2 && second - third > 3) {
    return 'dual'; // 双核型
  } else {
    return 'gradient'; // 渐变型
  }
}

// ============ 分析主副差距 ============
function analyzeGap(scores) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const gap = sorted[0][1] - sorted[1][1];
  
  if (gap > 5) return 'large';
  if (gap >= 3) return 'medium';
  return 'small';
}

// ============ 生成唯一标识符 ============
function generateUniqueSignature(scores, answers) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const top5 = sorted.slice(0, 5).map(s => `${s[0]}:${s[1]}`).join('-');
  const answerHash = answers ? answers.slice(0, 5).map(a => a?.archetype?.[0] || 'x').join('') : '';
  return `${top5}|${answerHash}`;
}


// ============ 异化描述模板 ============
const alienationTemplates = {
  ruler: '当控制欲过强时，你可能会忽视他人的声音，陷入孤独的权力中心。',
  hero: '当英雄情结膨胀时，你可能会把所有关系变成竞技场，赢得战斗却失去战友。',
  sage: '当追求真理变成傲慢时，你可能会用理性审判一切，疏远那些"不够聪明"的人。',
  explorer: '当探索变成逃避时，你可能会用"在路上"回避所有需要停下来面对的问题。',
  outlaw: '当叛逆成为习惯时，你可能会为反对而反对，被"反对"本身所束缚。',
  magician: '当幻想与现实模糊时，你可能会沉溺于自我编织的美好叙事，逃避现实问题。',
  creator: '当创造变成执念时，你可能会为了不同而不同，在自己的宇宙里越走越远。',
  lover: '当对爱的渴望变成依赖时，你可能会在关系中迷失自我，用讨好换取安全感。',
  caregiver: '当照顾变成控制时，你可能会用"为你好"绑架他人，却忘了自己也需要被照顾。',
  jester: '当幽默成为盾牌时，你可能会用笑话堵住所有通向内心的入口，在人群中央却感到孤独。',
  everyman: '当归属感变成恐惧时，你可能会过度迎合群体，磨平自己所有的棱角。',
  innocent: '当乐观变成逃避时，你可能会拒绝承认任何负面的存在，把自己包裹在泡泡里。',
};

// ============ 次要原型对异化的影响 ============
const secondaryAlienationInfluence = {
  ruler: '加上你的控制倾向，这种模式可能会更加固化。',
  hero: '加上你的好胜心，你可能会在这条路上走得更远。',
  sage: '加上你的分析习惯，你可能会为这种行为找到"合理"的解释。',
  explorer: '加上你的逃避倾向，你可能会选择离开而非面对。',
  outlaw: '加上你的叛逆性格，你可能会更加固执己见。',
  magician: '加上你的幻想倾向，你可能会美化这种状态。',
  creator: '加上你的完美主义，你可能会陷入自我批判的循环。',
  lover: '加上你的情感依赖，这种模式可能会影响你的亲密关系。',
  caregiver: '加上你的付出习惯，你可能会在照顾他人中忽视自己。',
  jester: '加上你的回避方式，你可能会用幽默掩盖真实的问题。',
  everyman: '加上你的从众心理，你可能会更难坚持自己的立场。',
  innocent: '加上你的理想主义，你可能会对现实感到更大的落差。',
};

// ============ 建议模板 ============
const vacationSuggestions = {
  ruler: '试着放下控制，让别人来主导一次决定。去一个完全陌生的地方，不做任何计划，随遇而安。',
  hero: '允许自己示弱，体验"不需要拯救任何人"的轻松。找一件你一直想做但害怕失败的事，用最笨的方法去尝试。',
  sage: '做一件完全"不理性"的事情，比如在雨天出门散步，或者买一件没用但好看的东西。',
  explorer: '在熟悉的地方像游客一样认真逛一次，发现那些你从未注意过的角落。',
  outlaw: '认真研究一个你曾经激烈反对的观点，不是为了认同，而是为了理解。',
  magician: '关掉所有滤镜，用原相机拍一张此刻的自己，不修图直接保存。',
  creator: '临摹一件经典的、"俗气"的作品，体验"模仿"而非"创造"的感觉。',
  lover: '独自去一家餐厅，享受"只取悦自己"的用餐体验。给自己写一封情书。',
  caregiver: '找一个你一直在照顾的人，认真问他："你觉得我有什么需要帮助的地方吗？"然后真的让他帮你。',
  jester: '给一个重要的人写一封不搞笑的手写信，认真表达你的感谢或歉意。',
  everyman: '坚持表达一个可能不被认同的真实观点，观察会发生什么。',
  innocent: '选一部结局不完美的电影，完整看完，让那个不完美停在那里。',
};

// ============ 最低分原型的平衡建议 ============
const balanceSuggestions = {
  ruler: '尝试在小事上做一次决定者，体验掌控的感觉。',
  hero: '找一个小挑战，体验克服困难的成就感。',
  sage: '花时间深入研究一个你好奇的话题，享受求知的乐趣。',
  explorer: '去一个你从未去过的地方走走，哪怕只是城市的另一个角落。',
  outlaw: '质疑一个你一直接受的"规则"，问问自己为什么要遵守它。',
  magician: '允许自己做一个不切实际的白日梦，不要急着否定它。',
  creator: '动手做一件小东西，不管好不好看，享受创造的过程。',
  lover: '对一个重要的人表达你的感谢，用语言或行动。',
  caregiver: '主动关心一下身边人的状态，问一句"你还好吗"。',
  jester: '用幽默化解一次尴尬的场合，或者给自己讲一个笑话。',
  everyman: '和一个普通朋友进行一次深入的对话，聊聊真实的想法。',
  innocent: '相信一次"一切都会好起来"，给自己一点希望。',
};

// ============ 主要导出函数 ============

/**
 * 生成个性化特点描述
 * 综合考虑：主副组合、得分分布、第三原型、得分差距
 */
export function generatePersonalizedFeature(scores, primaryKey, answers) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const primary = sorted[0];
  const secondary = sorted[1];
  const tertiary = sorted[2];
  
  const primaryName = archetypes[primary[0]]?.name || primary[0];
  const secondaryName = secondary ? (archetypes[secondary[0]]?.name || secondary[0]) : null;
  
  let result = [];
  
  // 1. 主副组合描述（132种独特组合）
  if (secondary) {
    const comboKey = `${primary[0]}+${secondary[0]}`;
    const comboDesc = combinationDescriptions[comboKey];
    if (comboDesc) {
      result.push(comboDesc);
    }
  }
  
  // 2. 得分分布模式分析
  const distribution = analyzeDistribution(scores);
  const distributionInfo = distributionPatterns[distribution];
  if (distributionInfo) {
    result.push(distributionInfo.description);
  }
  
  // 3. 第三原型的隐藏影响
  if (tertiary && tertiary[1] > 2) {
    const tertiaryInfluence = tertiaryInfluences[tertiary[0]];
    if (tertiaryInfluence) {
      result.push(tertiaryInfluence);
    }
  }
  
  // 4. 得分差距分析
  const gap = analyzeGap(scores);
  const gapInfo = gapAnalysis[gap];
  if (gapInfo && gap !== 'medium') { // 只在差距明显时添加
    result.push(gapInfo.implication);
  }
  
  return result.join('');
}

/**
 * 生成个性化异化描述
 * 综合考虑：主原型异化 + 次要原型影响 + 得分分布
 */
export function generatePersonalizedAlienation(scores, primaryKey) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const primary = sorted[0];
  const secondary = sorted[1];
  
  let result = [];
  
  // 1. 主原型的异化描述
  const primaryAlienation = alienationTemplates[primary[0]];
  if (primaryAlienation) {
    result.push(primaryAlienation);
  }
  
  // 2. 次要原型对异化的影响
  if (secondary && secondary[1] > 3) {
    const secondaryInfluence = secondaryAlienationInfluence[secondary[0]];
    if (secondaryInfluence) {
      result.push(secondaryInfluence);
    }
  }
  
  // 3. 根据得分分布添加特定警示
  const distribution = analyzeDistribution(scores);
  if (distribution === 'dominant') {
    result.push('由于你的能量高度集中，这种倾向可能会更加明显。');
  } else if (distribution === 'dual') {
    result.push('你的双重原型可能会在这种状态下产生内心冲突。');
  }
  
  return result.join('');
}

/**
 * 生成个性化建议
 * 综合考虑：主原型建议 + 最低分原型平衡 + 分布模式建议
 */
export function generatePersonalizedVacation(scores, primaryKey, answers) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const primary = sorted[0];
  const lowest = sorted[sorted.length - 1];
  
  let result = [];
  
  // 1. 主原型的核心建议
  const primarySuggestion = vacationSuggestions[primary[0]];
  if (primarySuggestion) {
    result.push(primarySuggestion);
  }
  
  // 2. 最低分原型的平衡建议
  if (lowest && lowest[1] === 0) {
    const balanceSuggestion = balanceSuggestions[lowest[0]];
    if (balanceSuggestion) {
      result.push(`另外，你可能需要${balanceSuggestion}`);
    }
  }
  
  // 3. 根据分布模式添加建议
  const distribution = analyzeDistribution(scores);
  const distributionInfo = distributionPatterns[distribution];
  if (distributionInfo?.advice) {
    result.push(distributionInfo.advice);
  }
  
  return result.join('');
}

/**
 * 生成完整的个性化分析报告
 * 返回所有维度的分析结果
 */
export function generateFullAnalysis(scores, answers) {
  const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  const primaryKey = sorted[0][0];
  
  return {
    feature: generatePersonalizedFeature(scores, primaryKey, answers),
    alienation: generatePersonalizedAlienation(scores, primaryKey),
    vacation: generatePersonalizedVacation(scores, primaryKey, answers),
    distribution: analyzeDistribution(scores),
    gap: analyzeGap(scores),
    signature: generateUniqueSignature(scores, answers),
    topArchetypes: sorted.slice(0, 5).map(([key, score]) => ({
      key,
      name: archetypes[key]?.name || key,
      score,
    })),
  };
}
